"use client";

import { createTRPCReact } from "@trpc/react-query";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import superjson from "superjson";

import type { AppRouter } from "@ept/api";
import { env } from "@ept/env/src/env-frontend";
import { v4 } from "uuid";

export const api = createTRPCReact<AppRouter>({});

export const apiVanilla = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      transformer: superjson,
      url: `${env.NEXT_PUBLIC_SERVERSIDE_HOST}/trpc`,
      fetch(url, options) {
        return fetch(url, {
          ...options,
          headers: {
            ...options?.headers,
            "x-request-id": v4(),
          },
          credentials: "include",
        });
      },
    }),
  ],
});

export { type RouterInputs, type RouterOutputs } from "@ept/api";
